import { useQuery } from "@tanstack/react-query";
import instance from "services/axiosServices";

export function useListarRendasFamiliares() {
  const fetchData = async () => {
    const LISTAR_RENDAS_FAMILIARES = `dadoscomum/rendas-familiares`;
    const response = await instance.get(LISTAR_RENDAS_FAMILIARES);
    const dataWithPagination = {
      data: response?.data?.data,
      pagination: response?.data?.pagination,
    };
    return dataWithPagination;
  };
  const query = useQuery({
    queryFn: () => fetchData(),
    refetchOnWindowFocus: false,
    queryKey: ["listar_rendas_familiares"],
    refetchOnMount: true,
  });
  return query;
}
